var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_1097_61444",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "181",
            height: "136",
          },
        },
        [
          _c("rect", {
            attrs: { width: "181", height: "136", fill: "#F5F5F5" },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_1097_61444)" } }, [
        _c("rect", { attrs: { width: "181", height: "136", fill: "#27D8FF" } }),
        _c("circle", {
          attrs: { cx: "60.5", cy: "96.5", r: "83.5", fill: "#83F8FF" },
        }),
        _c("circle", {
          attrs: { cx: "54", cy: "97", r: "54", fill: "#06E7F7" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }